import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Textarea — modern rounded, token-driven.
 * Radius: rounded-xl. Focus ring via global :focus-visible.
 */
const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[120px] w-full rounded-xl border border-line bg-transparent px-4 py-3 text-base text-ink",
        "transition-colors duration-hover ease-out",
        "placeholder:text-muted",
        "hover:border-ink",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
